document.addEventListener('DOMContentLoaded', function() {
    // Support all parallax structures:
    // 1. .parallax-block > .parallax > .parallax__wrapper > .parallax__content > .parallax__images > .parallax__image
    // 2. .parallax-hero-block > .parallax-hero > .parallax-hero__wrapper > .parallax-hero__content > .parallax-hero__images > .parallax-hero__image
    // 3. .parallax-team-block > .parallax-team > .parallax-team__wrapper > .parallax-team__content > .parallax-team__images > .parallax-team__image
    // 4. .parallax-home-block > .parallax-home > .parallax-home__wrapper > .parallax-home__content > .parallax-home__images > .parallax-home__image
    // 5. .parallax-dynamic-block > .parallax-dynamic > .parallax-dynamic__wrapper > .parallax-dynamic__content > .parallax-dynamic__images > .parallax-dynamic__image
    const parallaxContainers = document.querySelectorAll('.parallax-block .parallax__images, .parallax-hero-block .parallax-hero__images, .parallax-team-block .parallax-team__images, .parallax-home-block .parallax-home__images, .parallax-dynamic-block .parallax-dynamic__images');
    
    if (parallaxContainers.length === 0) return;
    
    // Parallax configuration with direction control
    const parallaxConfig = {
        speed: {
            image1: { speed: 1.3, direction: 'down' },  // Slowest (background)
            image2: { speed: 1.5, direction: 'down' },  // Medium
            image3: { speed: 1.7, direction: 'up' },    // Faster
            image4: { speed: 1.9, direction: 'up' }    // Fastest (foreground)
        },
        heroSpeed: {
            image1: { speed: 1.3, direction: 'down' },  // Slowest (background)
            image2: { speed: 0.8, direction: 'up' },      // Slower for hero
            image3: { speed: 1.7, direction: 'up' },     // Faster
            image4: { speed: 1.9, direction: 'up' }       // Fastest (foreground)
        },
        teamSpeed: {
            image1: { speed: .6, direction: 'down' },   // Slowest (background)
            image2: { speed: .3, direction: 'down' },   // Medium
            image3: { speed: .3, direction: 'up' },    // Faster
            image4: { speed: 1.8, direction: 'down' }     // Fastest (foreground)
        },
        homeSpeed: {
            image1: { speed: 0.5, direction: 'down' },   // Slowest (background)
            image2: { speed: 0.7, direction: 'up' },   // Medium
        },
        dynamicSpeed: {
            image1: { speed: 0.8, direction: 'down' },   // Background layer
            image2: { speed: 1.2, direction: 'down' },     // Main hero image
            image3: { speed: .4, direction: 'up' },   // Foreground layer
        },
        threshold: 0.1,
        rootMargin: '0px 0px -10% 0px'
    };
    
    // Intersection Observer for performance
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('parallax-active');
            } else {
                entry.target.classList.remove('parallax-active');
            }
        });
    }, {
        threshold: parallaxConfig.threshold,
        rootMargin: parallaxConfig.rootMargin
    });
    
    parallaxContainers.forEach(container => {
        // Check block type first
        const isParallaxHero = container.closest('.parallax-hero-block');
        const isParallaxTeam = container.closest('.parallax-team-block');
        const isParallaxHome = container.closest('.parallax-home-block');
        const isParallaxDynamic = container.closest('.parallax-dynamic-block');
        
        // For team blocks, use wrappers; for others, use images
        let images;
        if (isParallaxTeam) {
            images = container.querySelectorAll('.parallax-team__image-wrapper');
        } else {
            images = container.querySelectorAll('.parallax__image, .parallax-hero__image, .parallax-team__image, .parallax-home__image, .parallax-dynamic__image');
        }
        
        // Observe each container
        observer.observe(container);
        
        // Add data attributes for parallax speeds
        images.forEach((img, index) => {
            const imageNumber = index + 1;
            const speedKey = `image${imageNumber}`;
            
            let speedConfig;
            if (isParallaxHero) {
                speedConfig = parallaxConfig.heroSpeed;
            } else if (isParallaxTeam) {
                speedConfig = parallaxConfig.teamSpeed;
            } else if (isParallaxHome) {
                speedConfig = parallaxConfig.homeSpeed;
            } else if (isParallaxDynamic) {
                speedConfig = parallaxConfig.dynamicSpeed;
            } else {
                speedConfig = parallaxConfig.speed;
            }
            
            const imageConfig = speedConfig[speedKey] || { speed: 0.5, direction: 'down' };
            img.setAttribute('data-parallax-speed', imageConfig.speed);
            img.setAttribute('data-parallax-direction', imageConfig.direction);
            img.classList.add('parallax-image');
        });
        
        // Parallax scroll handler
        function handleParallax() {
            if (!container.classList.contains('parallax-active')) return;
            
            const rect = container.getBoundingClientRect();
            const scrollTop = window.pageYOffset;
            const elementTop = rect.top + scrollTop;
            const elementHeight = container.offsetHeight;
            const windowHeight = window.innerHeight;
            
            // Check block type for appropriate trigger behavior
            const isParallaxHero = container.closest('.parallax-hero-block');
            const isParallaxTeam = container.closest('.parallax-team-block');
            const isParallaxHome = container.closest('.parallax-home-block');
            const isParallaxDynamic = container.closest('.parallax-dynamic-block');
            
            // Disable parallax for team blocks at 1050px and below
            if (isParallaxTeam && window.innerWidth <= 1050) {
                images.forEach((img) => {
                    img.style.transform = 'translateY(0px)';
                });
                return;
            }
            
            // Calculate parallax offset
            let scrolled, rate;
            if (isParallaxHero || isParallaxDynamic) {
                // For hero blocks, start parallax when element is more centered
                const heroTriggerOffset = windowHeight * 0.3; // Start when 30% into viewport
                scrolled = scrollTop + windowHeight - heroTriggerOffset;
                const adjustedElementTop = elementTop + heroTriggerOffset;
                rate = (scrolled - adjustedElementTop) / (elementHeight + windowHeight - heroTriggerOffset);
                
                // Ensure rate is between 0 and 1, and reset to 0 when at top
                if (rate < 0) rate = 0;
                if (rate > 1) rate = 1;
            } else {
                // Regular parallax calculation
                scrolled = scrollTop + windowHeight;
                rate = (scrolled - elementTop) / (elementHeight + windowHeight);
            }
            
            images.forEach((img, index) => {
                const speed = parseFloat(img.getAttribute('data-parallax-speed'));
                const direction = img.getAttribute('data-parallax-direction') || 'down';
                
                // Calculate movement based on direction attribute
                let offset;
                if (direction === 'up') {
                    offset = -rate * 100 * speed; // Move up
                } else {
                    offset = rate * 100 * speed; // Move down (default)
                }
                
                // Apply transform with smooth easing
                img.style.transform = `translateY(${offset}px)`;
            });
        }
        
        // Throttled scroll handler for performance
        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(() => {
                    handleParallax();
                    ticking = false;
                });
                ticking = true;
            }
        }
        
        // Add scroll listener
        window.addEventListener('scroll', requestTick, { passive: true });
        
        // Initial calculation
        handleParallax();
    });
});
